<template>
    <div class="fund-list">
        <el-row v-if="fundInfo.length <= 0 && hasLoad" class="no-funds">
            <el-col :span="12" :offset="8">
                <span class="no-funds-img" />
                <div class="no-funds-box">
                    <p>{{ noFundMsg }}</p>
                </div>
            </el-col>
        </el-row>
        <el-table
            v-else-if="hasLoad && pageHasLoad"
            :data="fundAll"
            style="width: 100%"
            class="tab-list-tit"
            :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
            v-on:sort-change="handleSortChange"
        >
            <!-- 普通表头和货币表头会动态切换，固定key避免ElementUI复用列实例导致顺序错乱。 -->
            <el-table-column
                key="fund-name"
                :label="isCurrencyList ? '基金名称' : '产品名称'"
                :width="isCompactCurrencyStageTable ? 260 : 200"
                class-name="fund-offset"
            >
                <template slot-scope="scope">
                    <div class="fund-name" v-on:click.stop="gotoDetail(scope.row)">
                        <span class="fund-name-text">{{ scope.row.fundname }}</span>
                        <!-- 快赎判断 -->
                        <span v-if="scope.row.allowfastredeemflag === '1'" class="fund-name-icon">
                            快
                        </span>
                    </div>
                    <div>
                        {{ scope.row.fundcode }}
                        <!-- FOF-7 -->
                        <span
                            v-if="
                                scope.row.fundshowtype === '7' &&
                                scope.row.cycleratevalue &&
                                scope.row.cycleratetype
                            "
                        >
                            | 封闭期{{
                                scope.row.cycleratevalue +
                                $cache.getDict("220027", scope.row.cycleratetype)
                            }}
                        </span>
                        <span v-if="$util.hasFM(scope.row)" class="fm1">浮动管理费基金</span>
                        <span
                            v-if="showLimitCountFlag && checkShowLimitFlag(scope.row)"
                            class="fm1"
                        >
                            {{ formatDailyPurchaseLimit(scope.row) }}
                        </span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isCurrencyList"
                key="currency-fund-type"
                label="基金类型"
                align="center"
                min-width="120"
            >
                <template slot-scope="scope">
                    <span>{{ getFundTypeText(scope.row) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isCurrencyList"
                key="currency-navdate"
                prop="navdate"
                label="净值日期"
                align="center"
                min-width="110"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.navdate ? $util.fmtDate(scope.row.navdate) : "--" }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isCurrencyList"
                key="currency-fundincomeunit"
                prop="fundincomeunit"
                label="万份收益"
                align="center"
                min-width="110"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span>{{ formatFundIncomeUnit(scope.row.fundincomeunit) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isCurrencyList"
                key="currency-growthrate"
                prop="growthrate"
                label="7日年化"
                align="center"
                min-width="110"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span :class="rateClass(scope.row.growthrate)">
                        {{ formatterCurrencyAnnualRate(scope.row.growthrate) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="!isCurrencyList"
                key="normal-nav"
                prop="nav"
                :width="isCompactCurrencyStageTable ? 220 : 120"
                :label="
                    tabIndex == '' || tabIndex == '0'
                        ? '单位净值/万份收益'
                        : tabIndex != '5'
                        ? '单位净值'
                        : '每万份收益'
                "
                align="center"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <div v-if="!isCurrencyMetricRow(scope.row)">
                        <div>
                            {{ $util.fmtNum(scope.row.nav, 4) }}
                        </div>
                        <div v-if="scope.row.nav" style="color: var(--color-text-regular)">
                            {{ $util.fmtDate(scope.row.navdate) }}
                        </div>
                    </div>
                    <div v-else>
                        <div>
                            {{ $util.fmtNum(scope.row.fundincomeunit, 4) }}
                        </div>
                        <div
                            v-if="scope.row.fundincomeunit"
                            style="color: var(--color-text-regular)"
                        >
                            {{ $util.fmtDate(scope.row.navdate) }}
                        </div>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column v-if="tabIndex != '5'" label="累计净值" align="center">
                    <template slot-scope="scope">
                        <div>{{ $util.fmtNum(scope.row.totalnav, 4) }}</div>
                    </template>
                </el-table-column> -->
            <el-table-column
                v-if="!isCurrencyList"
                key="normal-dayfloatprofit"
                prop="dayfloatprofit"
                :width="isCompactCurrencyStageTable ? 220 : 130"
                :label="
                    tabIndex == '' || tabIndex == '0'
                        ? '日涨跌幅/7日年化'
                        : tabIndex != '5'
                        ? '日涨跌幅'
                        : '7日年化收益'
                "
                align="center"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span
                        v-if="!isCurrencyMetricRow(scope.row)"
                        :class="
                            scope.row.dayfloatprofit > 0
                                ? 'add'
                                : scope.row.dayfloatprofit < 0
                                ? 'reduce'
                                : ''
                        "
                    >
                        {{ formatterRate(scope.row.dayfloatprofit) }}
                    </span>
                    <span
                        v-else
                        :class="
                            scope.row.growthrate > 0
                                ? 'add'
                                : scope.row.growthrate < 0
                                ? 'reduce'
                                : ''
                        "
                    >
                        {{ formatterCurrencyAnnualRate(scope.row.growthrate) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="!isCurrencyList && !shouldHideCurrencyStage"
                key="normal-month6ud"
                prop="month6ud"
                label="近六月"
                align="center"
                min-width="100"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span :class="rateClass(scope.row.month6ud, isCurrencyStageRate(scope.row))">
                        {{ formatterStageRate(scope.row.month6ud, scope.row) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="!shouldHideCurrencyStage"
                key="year1ud"
                prop="year1ud"
                label="近一年"
                align="center"
                min-width="100"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span :class="rateClass(scope.row.year1ud, isCurrencyStageRate(scope.row))">
                        {{ formatterStageRate(scope.row.year1ud, scope.row) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="!shouldHideCurrencyStage"
                key="thisyear1ud"
                prop="thisyear1ud"
                label="今年以来"
                align="center"
                min-width="110"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span :class="rateClass(scope.row.thisyear1ud, isCurrencyStageRate(scope.row))">
                        {{ formatterStageRate(scope.row.thisyear1ud, scope.row) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isCurrencyList && !shouldHideCurrencyStage"
                key="currency-allud"
                prop="allud"
                label="成立以来"
                align="center"
                min-width="110"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span :class="rateClass(scope.row.allud, isCurrencyStageRate(scope.row))">
                        {{ formatterStageRate(scope.row.allud, scope.row) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="!isCurrencyList && !shouldHideCurrencyStage"
                key="normal-year3ud"
                prop="year3ud"
                label="近三年"
                align="center"
                min-width="100"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span :class="rateClass(scope.row.year3ud, isCurrencyStageRate(scope.row))">
                        {{ formatterStageRate(scope.row.year3ud, scope.row) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="!isCurrencyList"
                key="normal-risklevel"
                prop="risklevel"
                label="风险等级"
                align="center"
                :width="isCompactCurrencyStageTable ? 240 : undefined"
                min-width="110"
                sortable="custom"
            >
                <template slot-scope="scope">
                    <span style="white-space: nowrap">
                        {{ $cache.getDict("110143", scope.row.risklevel) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="$util.getConfig().hideFunc"
                key="operation"
                label="操作"
                align="center"
                width="180"
            >
                <template slot-scope="scope">
                    <div class="btns">
                        <template
                            v-if="url !== 'glist' && xjbFundInfo.fundcode !== scope.row.fundcode"
                        >
                            <el-tooltip
                                v-if="scope.row.isBuy"
                                class="item"
                                effect="info"
                                :content="
                                    scope.row.isBuy +
                                    '，不能' +
                                    (scope.row.status == '1' ? '认购' : '申购')
                                "
                                placement="top"
                            >
                                <el-button disabled type="text" size="small">
                                    {{ scope.row.status == "1" ? "认购" : "申购" }}
                                </el-button>
                            </el-tooltip>
                            <el-button
                                v-else
                                type="text"
                                plain
                                size="small"
                                :class="{ 'is-disabled': $util.isPersonalBuyBusinessDisabled() }"
                                v-on:click.stop="callbackFn('20,22', scope.row)"
                            >
                                {{ scope.row.status == "1" ? "认购" : "申购" }}
                            </el-button>
                        </template>
                        <template v-if="xjbFundInfo.fundcode !== scope.row.fundcode && checkValid">
                            <div class="line"></div>
                            <el-tooltip
                                v-if="
                                    scope.row.fundclass != '1' &&
                                    scope.row.isCurrency &&
                                    xjbFundInfo.fundcode !== scope.row.fundcode
                                "
                                class="item"
                                effect="info"
                                :content="scope.row.isCurrency + '，不能定投'"
                                placement="top"
                            >
                                <el-button type="text" disabled size="small">定投</el-button>
                            </el-tooltip>
                            <el-button
                                v-if="
                                    scope.row.fundclass != '1' &&
                                    !scope.row.isCurrency &&
                                    xjbFundInfo.fundcode !== scope.row.fundcode
                                "
                                type="text"
                                plain
                                size="small"
                                :class="{ 'is-disabled': $util.isPersonalBuyBusinessDisabled() }"
                                v-on:click.stop="callbackFn('59', scope.row)"
                            >
                                定投
                            </el-button>
                        </template>

                        <template v-if="url !== 'glist' && $util.checkModuleid(100001003)">
                            <div
                                v-if="xjbFundInfo.fundcode !== scope.row.fundcode"
                                class="line"
                            ></div>
                            <el-button
                                v-if="scope.row.collection == '0'"
                                type="text"
                                plain
                                size="small"
                                style="width: 60px"
                                v-on:click.stop="collectFund(scope.row)"
                            >
                                加自选
                            </el-button>
                            <el-button
                                v-else
                                type="text"
                                plain
                                size="small"
                                style="width: 60px"
                                v-on:click.stop="unCollectFund(scope.row)"
                            >
                                取消自选
                            </el-button>
                        </template>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-row v-if="showPagination && allPage > 0" class="page-box">
            <el-pagination
                :page-size="Number(conf.PAGE_SIZE)"
                :current-page.sync="curPage"
                layout="->, total, prev, pager, next"
                :total="Number(allPage)"
                v-on:current-change="dataReset"
            />
        </el-row>
        <dalogChild width="520px" :dialogVisible.sync="showDialog"></dalogChild>
    </div>
</template>

<script>
import fundApi from "@/api/fund";
import dalogChild from "@/components/acctInfo/dalogChild.vue";

export default {
    name: "FundList",
    components: {
        dalogChild
    },
    props: {
        fundInfo: {
            type: Array,
            default: () => {
                return [];
            },
            required: true
        },
        allPage: {
            type: String,
            default: ""
        },
        noFundMsg: {
            type: String,
            default: "基金公司没有添加基金产品，请联系基金公司添加！ "
        },
        isCollection: {
            type: Boolean,
            default: false
        },
        hasLoad: {
            type: Boolean,
            default: false
        },
        tabIndex: {
            type: String,
            default: "0"
        },
        listType: {
            type: String,
            default: ""
        },
        showPagination: {
            type: Boolean,
            default: true
        },
        hideCurrencyStage: {
            type: Boolean,
            default: false
        },
        page: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            url: "", // 当前页面路由命名
            fundAll: [],
            curPage: 1,
            pageHasLoad: true,
            xjbFundInfo: {},
            showDialog: false, // 控制对话框显示状态
            checkValid: true // “基金定投”菜单是否放开
        };
    },
    computed: {
        isCurrencyList() {
            return this.listType === "currency";
        },
        shouldHideCurrencyStage() {
            // 10102049只约束货币基金阶段收益；普通非货基金列表不能因为该参数隐藏收益列。
            return this.hideCurrencyStage && (this.isCurrencyList || this.tabIndex === "5");
        },
        isCompactCurrencyStageTable() {
            // 普通货币型tab隐藏阶段收益后只剩少量列，固定宽度避免列被均摊得过散。
            return !this.isCurrencyList && this.tabIndex === "5" && this.shouldHideCurrencyStage;
        },
        showLimitCountFlag() {
            return this.$cache.getParamValue("fund_market").limittagenabled;
        },
        showCurrencyStageZeroAsPlaceholder() {
            // 10102051=0 时，货币基金阶段涨幅为 0 展示 0.00%；其他情况沿用旧的 "--" 展示。
            return this.$cache.getCompanyInfoParam("10102051") !== "0";
        }
    },
    watch: {
        fundInfo() {
            this.getNewFund("fundInfo");
        },
        tabIndex() {
            this.getNewFund("tabIndex");
        },
        // allPage() {
        //     this.curPage = 1;
        // },
        page(val) {
            this.curPage = val;
        }
    },
    mounted() {
        this.conf = this.$util.getConfig().const;
        this.url = this.$route.name;
        this.xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo")) || {};

        const menuModule =
            (this.$cache.getParamValue("menu_module") &&
                this.$cache.getParamValue("menu_module").menus) ||
            [];
        const getValidMenuIds = (menuModule) => {
            const ids = new Set();
            const traverse = (items) => {
                items.forEach((item) => {
                    ids.add(item.menuid);
                    if (item.menu) traverse(item.menu);
                });
            };
            traverse(menuModule);
            return Array.from(ids);
        };
        const validMenuIds = getValidMenuIds(menuModule);
        // 104-基金定投菜单，检查是否放开
        if (validMenuIds.length > 0 && !validMenuIds.includes(104)) {
            this.checkValid = false;
        }
    },
    methods: {
        // 货币指标只在“货币型”页展示；基金超市“全部”页要按表头展示单位净值/日涨跌幅。
        // 兼容旧的混合表头场景（tabIndex 为空或 0，例如我的自选），继续展示万份收益/7日年化。
        isCurrencyMetricRow(row) {
            const isMixedMetricTab = this.tabIndex === "" || this.tabIndex === "0";
            const isCurrencyTab = this.tabIndex === "5";
            return row && row.fundshowtype === "5" && (isCurrencyTab || isMixedMetricTab);
        },
        // 检查是否显示限额图标
        checkShowLimitFlag(fund) {
            const isLimit = fund.dailypurchaselimit > 0 && fund.dailypurchaselimit <= 1000000000;
            return this.showLimitCountFlag && isLimit;
        },
        formatDailyPurchaseLimit(fund) {
            const limit = Number(fund.dailypurchaselimit);
            if (!Number.isFinite(limit) || limit <= 0 || limit > 1000000000) {
                return "";
            }
            if (limit >= 100000000) {
                return `限${Math.floor(limit / 100000000)}亿元`;
            }
            if (limit >= 10000) {
                return `限${Math.floor(limit / 10000)}万元`;
            }
            return `限${Math.floor(limit)}元`;
        },
        // 跳转到基金详情
        gotoDetail(val) {
            this.$util.toFundDetailPage(val.fundcode);
        },
        // 关注基金
        async collectFund(item) {
            const res = await fundApi.collectFund({
                fundcode: item.fundcode
            });
            // if (!res.error) {
            //     this.$set(this.fundAll[item.index], "collection", "1");
            // }
            this.$emit("new-fund", "1");
        },
        // 取消关注基金
        async unCollectFund(item) {
            const res = await fundApi.unCollectFund({
                fundcode: item.fundcode
            });
            // if (!res.error) {
            //     this.$set(this.fundAll[item.index], "collection", "0");
            // }
            this.$emit("new-fund", "1");
        },
        async callbackFn(way, fund) {
            if (
                this.$util.checkPersonalBuyBusinessDisabled(
                    way == "59" ? "定投" : fund.status == "1" ? "认购" : "申购"
                )
            ) {
                return;
            }
            let moduleId = "";
            if (way == "59") {
                moduleId = way;
            } else {
                if (fund.status == "1") {
                    moduleId = "20";
                } else {
                    moduleId = "22";
                }
            }
            // 不允许进入交易页面交易
            // 未认证投资者限制交易弹窗业务类型需要根据综合理财勾选的限制业务来提示
            const limitFlag = await this.$util.shouldShowCertificateDialog("0" + moduleId);
            if (limitFlag) {
                this.showDialog = true;
                return;
            }
            // 申购 22 认购 20
            this.$util.checkGtOcrModule(moduleId, "0", (res) => {
                this.$emit("fund-continue", way, fund);
            });
        },
        triggerTradeByFundCode(way, fundcode) {
            const targetFund = this.fundAll.find((item) => item.fundcode === fundcode);
            if (!targetFund) {
                return { status: "missing" };
            }
            const shouldBlockBuy = !!targetFund.isBuy;
            const shouldBlockPlan =
                targetFund.fundclass == "1" || !!targetFund.isCurrency || !this.checkValid;
            if (way === "59" && shouldBlockPlan) {
                return { status: "blocked" };
            }
            if (way !== "59" && shouldBlockBuy) {
                return { status: "blocked" };
            }
            this.callbackFn(way, targetFund);
            return { status: "triggered" };
        },
        getNewFund(val) {
            this.pageHasLoad = false;
            let _arr = [];
            this.fundInfo.forEach((fund, index) => {
                const _x = Object.assign({}, fund);
                _x.index = index;
                _x.isBuy = this.$util.checkBuy(_x);
                _x.isCurrency = this.$util.checkGeneral(_x);
                _arr.push(_x);
            });
            this.fundAll = _arr;
            if (val == "fundInfo") {
                this.pageHasLoad = true;
            }
        },
        dataReset(val) {
            this.$emit("new-fund", val);
        },
        handleSortChange({ prop, order }) {
            this.curPage = 1;
            this.$emit("sort-change", {
                prop: prop || "",
                order: order || "",
                listType: this.listType
            });
        },
        getFundTypeText(row) {
            // 货币基金分列表优先按展示类型取字典，缺失时回退到原基金类型字典。
            return (
                this.$cache.getDict("130086", row.fundshowtype) ||
                this.$cache.getDict("110144", row.fundtype) ||
                "--"
            );
        },
        formatFundIncomeUnit(val) {
            if (val === "" || val === null || val === undefined) {
                return "--";
            }
            return this.$util.fmtNum(val, 4);
        },
        isEmptyCurrencyStageValue(rate) {
            const isEmpty = rate === "" || rate === null || rate === undefined;
            return isEmpty || (this.showCurrencyStageZeroAsPlaceholder && Number(rate) === 0);
        },
        isCurrencyStageRate(row) {
            return this.isCurrencyList || (row && row.fundshowtype === "5");
        },
        rateClass(rate, currencyStage = false) {
            if (currencyStage && this.isEmptyCurrencyStageValue(rate)) {
                return "";
            }
            return Number(rate) > 0 ? "add" : Number(rate) < 0 ? "reduce" : "";
        },
        formatterStageRate(rate, row) {
            // 货币基金阶段收益只要展示，缺失或接口回0都按需求展示“--”，不受隐藏参数本身影响。
            if (this.isCurrencyStageRate(row) && this.isEmptyCurrencyStageValue(rate)) {
                return "--";
            }
            return this.formatterRate(rate);
        },
        formatterCurrencyAnnualRate(rate) {
            // 货币基金7日年化按产品口径固定展示3位小数，避免复用通用涨跌幅的2位精度。
            return this.formatterRate(rate, 3);
        },
        // 格式化涨跌幅数据
        formatterRate(rate, precision = 2) {
            if (rate === "" || rate === null || rate === undefined) {
                return "--";
            }
            const prefix = Number(rate) > 0 ? "+" : "";
            return prefix + this.$util.fmtNum(rate, precision) + "%";
        }
    }
};
</script>
<style lang="scss" scoped>
.fund-list {
    padding-bottom: 0;
    .el-table td.el-table__cell div {
        color: var(--color-text-primary);
    }
    .el-table td.el-table__cell span {
        color: #333333;
        &.add {
            color: var(--color-up);
        }
        &.reduce {
            color: var(--color-down);
        }
    }
    .el-table--fit {
        margin-bottom: 20px;
    }
    .fund-name {
        display: flex;
        align-items: center;

        .fund-name-text {
            cursor: pointer;
            max-width: calc(100% - 30px);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .fund-name-icon {
            display: inline-block;
            background: #fbecee;
            font-size: 12px;
            line-height: 18px;
            width: 18px;
            text-align: center;
            margin-left: 6px;
            font-size: 11px;
            color: var(--color-risk-level-3) !important;
            line-height: 16px;
        }
        .fund-limit-icon {
            display: inline-block;
            height: 18px;
            padding: 0 6px;
            font-weight: 400;
            font-size: 12px;
            color: #ffffff !important;
            text-align: center;
            line-height: 18px;
            border-radius: 6px 3px;
            margin-left: 6px;
            background: linear-gradient(270deg, #ffa0a0 0%, #ff545b 100%);
        }
    }
    .collection-name {
        font-weight: 400;
        font-size: 14px;
    }
    .btns {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 11px;
    }
    .line {
        background: var(--color-divided);
        width: 1px;
        height: 12px;
    }
    .el-button.is-plain:hover,
    .el-button.is-plain:focus,
    .el-button.is-disabled.is-plain {
        background-color: transparent;
        border-color: transparent;
    }
    .el-button--text {
        font-size: 14px;
        font-weight: normal;
        color: var(--color-primary);
    }
    .el-button--text.is-disabled {
        color: var(--color-text-placeholder);
    }
    .el-table {
        border: 1px solid #f1f1f1;
    }
    .page-box {
        padding: 0;
    }
    .el-pagination {
        margin-bottom: 0;
    }
}
</style>
